<template>
  <v-app id="app">
    <v-main>
      <v-container fluid class="main-body pa-3">
        <router-view/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="scss">

body .theme--light.v-application {
  font-family: "brandon-grotesque", sans-serif;
  font-weight: 400;
  font-style: normal;

  h1,h2,h3,h4,h5,h6 {
    font-family: "patrick-hand-sc", sans-serif;
    font-weight: 400;
    font-style: normal;
    text-transform: uppercase;
  }
}

#app {
  background-color: #ffffff;
}

.main-body {
  min-height: 100vh;
  background-color: #ffffff;
  box-shadow: 1px 0px 24px rgba(0,0,0,0.3);
}

.v-main__wrap {
  background-color: #ede4db;
}

.text-center {
  text-align: center;
}
</style>
